import axios from "axios"

const state = {
  STATUS: null,
  API_ROUTE: "/doctors",
  doctorsList: [],
  totalDoctors: 0
}

const getters = {
  doctorsList: (state) => state.doctorsList,
  totalDoctors: (state) => state.totalDoctors
}

const mutations = {
  setDoctors(state, doctors) {
    state.doctorsList = doctors
  },
  setTotalDoctors(state, total) {
    state.totalDoctors = total
  }
}

const actions = {
  async listAllDoctors({ commit }, { offset = 0, limit = 10, search = null, orgId = null } = {}) {
    try {
      const userId = sessionStorage.getItem("userID")
      const url = `${process.env.VUE_APP_URL}${state.API_ROUTE}/${userId}`
      const config = {
        headers: {
          "Content-Type": "application/json"
        },
        params: { offset, limit, search, orgId }
      }

      const response = await window.axios.get(url, config)
      commit("setDoctors", response.data.doctors)
      commit("setTotalDoctors", response.data.total)
      return response.data
    } catch (error) {
      state.STATUS = "An error occurred: " + error
      throw error
    }
  },
  async listDoctorById({ commit }, doctorId) {
    try {
      const userId = sessionStorage.getItem("userID")
      const url = `${process.env.VUE_APP_URL}${state.API_ROUTE}/${userId}/${doctorId}`
      const config = {
        headers: {
          "Content-Type": "application/json"
        }
      }

      const response = await window.axios.get(url, config)
      return response.data
    } catch (error) {
      state.STATUS = "An error occurred: " + error
      throw error
    }
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
